import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import CreateJobModal from "components/Market/Jobs/CreateJobModal";

import * as marketReducer from "containers/Market/MarketReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";

class CreateJobModalContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <CreateJobModal {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createJob: (job) => dispatch(marketReducer.createJob(job)),
    updateIsCreateJob: (isCreateJob) => dispatch(marketReducer.updateIsCreateJob(isCreateJob)),
    handleBackModels: () => dispatch(nextModelsReducer.handleBack(ownProps.id))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    isCreateJob: marketReducer.getIsCreateJob(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(CreateJobModalContainer);
